export const formatDistance = (distance: number): string => {
  return `${(distance / 1000).toFixed(1)} km`
}
